import { Injectable } from '@angular/core';
import { filter, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OffersHttpService } from '@app/core/store/offers/offers-http.service';
import * as OfferActions from '@app/core/store/offers/offers-actions';
import { OfferMetadata } from '@app/core/_models/offer-interface';

@Injectable()
export class OffersEffects {
  public loadMetadata$ = createEffect(() => this.actions$.pipe(
    ofType(OfferActions.loadMetadata),
    switchMap(() => this.dataService.getOffersMetadata()),
    map((data: OfferMetadata) => OfferActions.metadataLoaded({ data })),
  ));

  public loadFilteredOffers$ = createEffect(() => this.actions$.pipe(
    ofType(OfferActions.loadFilteredOffers),
    switchMap(({ filters }) => this.dataService.getWithQuery(filters)),
    map(({ offers, pagination_info }) => OfferActions.offersLoaded({ offers, paginationInfo: pagination_info })),
  ));

  public loadOffer$ = createEffect(() => this.actions$.pipe(
    ofType(OfferActions.loadOffer),
    filter(action => action.id),
    switchMap(({ id }) => this.dataService.getById(id)),
    map((offer) => OfferActions.offerLoaded({ offer })),
  ));

  public useOffer$ = createEffect(() => this.actions$.pipe(
    ofType(OfferActions.useOffer),
    switchMap(({ id }) => this.dataService.useOffer(id)),
    map((offer) => OfferActions.offerUsed({ offer })),
  ));

  constructor(private actions$: Actions, private store: Store, private dataService: OffersHttpService) {
  }

}
